import { IGetReportJobStatusUseCase } from "../../../presentation/useCases/read/get_report_job_status_use_case";
import { GetReportJobStatusResponse } from "../../../data/daos/read/get_report_job_status";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportJobStatusUseCase
 */

export class GetReportJobStatusUseCase implements IGetReportJobStatusUseCase {
  constructor(private readonly repository: IReportsRepository) {}

  async getReportJobStatus(operacaoId: string): Promise<GetReportJobStatusResponse> {
    return await this.repository.getReportJobStatus(operacaoId);
  }
}
